/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip } from '@mui/material';

const PeriodoWeekChips = ({ chips, value, onChange }) => {
  if (!chips?.length) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        maxHeight: { xs: 88, sm: 'none' },
        overflowY: { xs: 'auto', sm: 'visible' },
      }}
    >
      {chips.map((chip) => {
        const isActive = value === chip.id;
        return (
          <Chip
            key={chip.id}
            label={chip.label}
            clickable
            color={isActive ? 'primary' : 'default'}
            variant={isActive ? 'filled' : 'outlined'}
            size="small"
            onClick={() => onChange(chip.id)}
            sx={{ fontWeight: isActive ? 600 : 400 }}
          />
        );
      })}
    </Box>
  );
};

PeriodoWeekChips.propTypes = {
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

PeriodoWeekChips.defaultProps = {
  chips: [],
  value: '',
};

export default PeriodoWeekChips;
